/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const snackTime = useStore((state) => state.snackTime);
  const setSnackTime = useStore((state) => state.setSnackTime);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.snackTime.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={snackTime}
          onChange={(value) => {
            setSnackTime(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'snack-time',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'morning'}>
            <span>🌅</span> {t('onboarding.snackTime.options.morning')}
          </Option>
          <Option value={'day'}>
            <span>🌇</span> {t('onboarding.snackTime.options.day')}
          </Option>
          <Option value={'night'}>
            <span>🌙</span> {t('onboarding.snackTime.options.night')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
